import useTranslateText from "./useTranslateText";

export default useTranslateText;
